$(document).ready(function () {

    $('.help-action button').on('click', function (i, v) {
        var $viewButton = $(this),
            $graphicSection = $viewButton.parents('.graphic-section'),
            $oldGraphic = $graphicSection.find('img.graphic'),
            $interactiveGraphic = $graphicSection.find('.interactive-graphic'),
            $svg = $('<object></object>');
        $svg.addClass('svg');
        $svg.attr('type', 'image/svg+xml');
        $svg.attr('data', $interactiveGraphic.data('src'));

        $viewButton.hide();
        $oldGraphic.hide();
        $interactiveGraphic.prepend($svg);
        $interactiveGraphic.show(); // displays the SVG and controls.
        svgPanZoomLoad($svg, $interactiveGraphic.find('.controls'));
    });


    $('.graphic').each(function (index) {
        $(this).on('error', function () {
            //hide 'View interactive image' button for images which have failed to load.
            $(this).next().hide();
        });
    });

    function svgPanZoomLoad($svg, $controls) {
        var svg = $svg[0];
        var HammerEventsHandler;

        function initialiseSvg() {
            if (svg.contentDocument.getElementsByTagName('svg').length) {
                HammerEventsHandler = {
                    haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
                    init: function (options) {
                        var instance = options.instance,
                            initialScale = 1,
                            pannedX = 0,
                            pannedY = 0;

                        // Init Hammer
                        // Listen only for pointer and touch events
                        this.hammer = Hammer(options.svgElement, {
                            inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
                        });

                        // Enable pinch
                        this.hammer.get('pinch').set({ enable: true });

                        // Handle double tap
                        this.hammer.on('doubletap', function (ev) {
                            instance.zoomIn();
                        });

                        // Handle pan
                        this.hammer.on('panstart panmove', function (ev) {
                            // On pan start reset panned variables
                            if (ev.type === 'panstart') {
                                pannedX = 0;
                                pannedY = 0;
                            }

                            // Pan only the difference
                            instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY });
                            pannedX = ev.deltaX;
                            pannedY = ev.deltaY;
                        });

                        // Handle pinch
                        this.hammer.on('pinchstart pinchmove', function (ev) {
                            // On pinch start remember initial zoom
                            if (ev.type === 'pinchstart') {
                                initialScale = instance.getZoom();
                                instance.zoom(initialScale * ev.scale);
                            }

                            instance.zoom(initialScale * ev.scale);

                        });

                        // Prevent moving the page on some devices when panning over SVG
                        options.svgElement.addEventListener('touchmove', function (e) {
                            e.preventDefault();
                        });
                    },
                    destroy: function () {
                        this.hammer.destroy();
                    }
                };

                //Prevent panning out of borders
                var preventGoingFromBorders = function (oldPan, newPan) {
                    var sizes = this.getSizes(),
                        gutterWidth = sizes.width,
                        gutterHeight = sizes.height,
                        leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth,
                        rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom),
                        topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight,
                        bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom);
                    var customPan = {};
                    customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
                    customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));
                    return customPan;
                };

                // Add height and width to svg element if none provided
                if (!svg.contentDocument.querySelector('svg[height]')) {
                    var viewBoxAttribute = svg.contentDocument.children[0].getAttribute('viewBox');
                    var viewBox = viewBoxAttribute ? viewBoxAttribute.split(' ') : undefined;
                    var sliceSourceBounds = svg.contentDocument.querySelector('sliceSourceBounds');
                    var height;
                    var width;

                    if (viewBox && viewBox.length === 4) {
                        height = Math.min(viewBox[3], sliceSourceBounds.attributes.height.value);
                        width = Math.min(viewBox[2], sliceSourceBounds.attributes.width.value);
                    } else {
                        height = sliceSourceBounds.attributes.height.value;
                        width = sliceSourceBounds.attributes.width.value;
                    }

                    if (height && width) {
                        svg.contentDocument.children[0].setAttribute('height', height);
                        svg.contentDocument.children[0].setAttribute('width', width);
                    }
                }

                // Initialize
                var panZoom = svgPanZoom(svg, {
                    viewportSelector: '.svg-pan-zoom_viewport',
                    zoomEnabled: true,
                    controlIconsEnabled: false,
                    fit: true,
                    zoomScaleSensitivity: 0.3,
                    center: true,
                    maxZoom: 10,
                    minZoom: 1,
                    beforePan: preventGoingFromBorders,
                    customEventsHandler: HammerEventsHandler
                });

                // Bind zoom in button
                $controls.find('.zoom-in').on('click touchstart', function (ev) {
                    ev.preventDefault();
                    panZoom.zoomIn();
                });

                // Bind zoom out button
                $controls.find('.zoom-out').on('click touchstart', function (ev) {
                    ev.preventDefault();
                    panZoom.zoomOut();
                });

                // Bind reset button
                $controls.find('.reset').on('click touchstart', function (ev) {
                    ev.preventDefault();
                    panZoom.fit();
                    panZoom.center();
                    panZoom.resetZoom();
                });
            }
            else {
                setTimeout(initialiseSvg, 500);
            }
        }

        svg.addEventListener('load', initialiseSvg, false); // Broken on IE8
    }
});
